<script>
import LinkHistoricoAlteracoes from './LinkHistoricoAlteracoes'
export default {
  name: 'DetalhesLogAlteracao',
  components: {LinkHistoricoAlteracoes},
  props: {
    logSelecionado: {
      type: Object,
      required: true
    }
  },
  computed: {
    possuiMotivo () {
      const isStatus = ['DELETE', 'STATUS_GRV'].some(status => this.logSelecionado.operacao === status)
      if (!isStatus) return false
      const {extra} = this.logSelecionado
      if (!extra) return false
      if (!extra.motivo) return false
      return true
    }
  }
}
</script>

<template>
  <transition name="slide">
    <div class="content-transition">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h3 class="m-n font-thin h3">Detalhes da alteração</h3></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel">
          <div class="panel-body">
            <div class="m-b-lg">
              Alteração realizada por: {{logSelecionado.username}}
              <link-historico-alteracoes
                :to="{name: 'usuarios.visualizar', params: {id: logSelecionado.usuario.id}}"
                label="Visualizar usuário"
                icon="fa-user-circle-o"
              ></link-historico-alteracoes>
              <div class="m-t-sm">Data: {{logSelecionado.data.date|formatDate('DD/MM/YYYY HH:mm:ss')}}</div>
              <div class="m-t-sm">Descrição da alteração: {{logSelecionado.descricao}}</div>
              <div class="m-t-sm">Entidade alterada: {{logSelecionado.entidade}}</div>
              <div class="m-t-sm" v-if="possuiMotivo">
                <strong>Motivo:</strong> {{ logSelecionado.extra.motivo || '-' }}
              </div>

              <div class="m-t-sm" v-if="logSelecionado.extra">
                <link-historico-alteracoes
                  v-if="logSelecionado.extra.oldArrematanteId"
                  :to="{name: 'arrematante.visualizar', params: {id: logSelecionado.extra.oldArrematanteId}}"
                  label="Visualizar arrematante anterior"
                  icon="fa-user"
                ></link-historico-alteracoes>

                <link-historico-alteracoes
                  v-if="logSelecionado.extra.newArrematanteId"
                  :to="{name: 'arrematante.visualizar', params: {id: logSelecionado.extra.newArrematanteId}}"
                  label="Visualizar novo arrematante"
                  icon="fa-user"
                ></link-historico-alteracoes>

                <link-historico-alteracoes
                  v-if="logSelecionado.extra.leilaoId"
                  :to="{name: 'lotes.visualizar', params: {leilao: logSelecionado.extra.leilaoId, id: logSelecionado.entidadeId}}"
                  label="Visualizar lote"
                  icon="fa-car"
                ></link-historico-alteracoes>
              </div>

              <div class="m-t-sm">
                <link-historico-alteracoes
                  v-if="logSelecionado.entidade === 'grv' && logSelecionado.operacao !== 'DELETE'"
                  :to="{name: 'grv.visualizar.patio', params: {id: logSelecionado.entidadeId}}"
                  label="Visualizar GRV"
                  icon="fa-file-text-o"
                ></link-historico-alteracoes>

                <link-historico-alteracoes
                  v-if="logSelecionado.entidade === 'usuario'"
                  :to="{name: 'usuarios.visualizar', params: {id: logSelecionado.entidadeId}}"
                  label="Visualizar usuário alterado"
                  icon="fa-user-circle-o"
                ></link-historico-alteracoes>

                <link-historico-alteracoes
                  v-if="logSelecionado.entidade === 'arrematante'"
                  :to="{name: 'arrematante.visualizar', params: {id: logSelecionado.entidadeId}}"
                  label="Visualizar arrematante"
                  icon="fa-user"
                ></link-historico-alteracoes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// DetalhesLogAlteracao.vue?6d49a398